import { render } from "./RegisterAgencyForm.vue?vue&type=template&id=52033c28"
import script from "./RegisterAgencyForm.vue?vue&type=script&lang=js"
export * from "./RegisterAgencyForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__